// // client/src/pages/user/InvoicesPage.jsx
// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import { 
//   FileText, Download, Loader2, Calendar, 
//   DollarSign, CheckCircle, Search, Filter
// } from 'lucide-react';
// import toast from 'react-hot-toast';
// import subscriptionAPI from '../../api/subscriptionAPI';

// const InvoicesPage = () => {
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [downloadingId, setDownloadingId] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');

//   useEffect(() => {
//     fetchInvoices();
//   }, []);

//   const fetchInvoices = async () => {
//     setLoading(true);
//     try {
//       const response = await subscriptionAPI.getBillingHistory();
//       setInvoices(response.data || response || []);
//     } catch (error) {
//       console.error('Error fetching invoices:', error);
//       toast.error('Failed to load invoices');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (date) => {
//     return new Date(date).toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const formatCurrency = (amount, currency = 'INR') => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: currency,
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const handleDownloadInvoice = async (invoiceId) => {
//     setDownloadingId(invoiceId);
//     try {
//       const blob = await subscriptionAPI.downloadInvoice(invoiceId);
      
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `invoice_${invoiceId}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//       toast.success('Invoice downloaded successfully');
//     } catch (error) {
//       console.error('Error downloading invoice:', error);
//       toast.error(error.response?.data?.message || 'Failed to download invoice');
//     } finally {
//       setDownloadingId(null);
//     }
//   };

//   const handleSendInvoice = async (invoiceId) => {
//     try {
//       await subscriptionAPI.sendInvoiceEmail(invoiceId);
//       toast.success('Invoice sent to your email');
//     } catch (error) {
//       console.error('Error sending invoice:', error);
//       toast.error(error.response?.data?.message || 'Failed to send invoice');
//     }
//   };

//   // Filter invoices
//   const filteredInvoices = invoices.filter(invoice => {
//     const matchesSearch = invoice.plan?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                           invoice._id?.toLowerCase().includes(searchTerm.toLowerCase());
//     const matchesStatus = filterStatus === 'all' || invoice.status === filterStatus;
//     return matchesSearch && matchesStatus;
//   });

//   const stats = {
//     total: invoices.length,
//     paid: invoices.filter(i => i.status === 'paid').length,
//     totalSpent: invoices.reduce((sum, i) => sum + (i.amount || i.price?.amount || 0), 0)
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-[60vh]">
//         <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-6">
//       {/* Header */}
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//       >
//         <h1 className="text-2xl font-bold text-gray-900 mb-2">Invoices</h1>
//         <p className="text-gray-500">View and download all your payment receipts</p>
//       </motion.div>

//       {/* Stats Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.1 }}
//           className="card p-4"
//         >
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Total Invoices</p>
//               <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
//             </div>
//             <FileText className="h-8 w-8 text-primary-600" />
//           </div>
//         </motion.div>

//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.15 }}
//           className="card p-4"
//         >
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Paid Invoices</p>
//               <p className="text-2xl font-bold text-green-600">{stats.paid}</p>
//             </div>
//             <CheckCircle className="h-8 w-8 text-green-600" />
//           </div>
//         </motion.div>

//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.2 }}
//           className="card p-4"
//         >
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Total Spent</p>
//               <p className="text-2xl font-bold text-gray-900">{formatCurrency(stats.totalSpent)}</p>
//             </div>
//             <DollarSign className="h-8 w-8 text-yellow-600" />
//           </div>
//         </motion.div>
//       </div>

//       {/* Search and Filter */}
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.25 }}
//         className="flex flex-col sm:flex-row gap-4"
//       >
//         <div className="flex-1 relative">
//           <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
//           <input
//             type="text"
//             placeholder="Search invoices..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="input-field pl-10"
//           />
//         </div>
//         <select
//           value={filterStatus}
//           onChange={(e) => setFilterStatus(e.target.value)}
//           className="input-field w-full sm:w-40"
//         >
//           <option value="all">All Status</option>
//           <option value="paid">Paid</option>
//           <option value="pending">Pending</option>
//           <option value="failed">Failed</option>
//         </select>
//       </motion.div>

//       {/* Invoices List */}
//       {filteredInvoices.length === 0 ? (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="card p-12 text-center"
//         >
//           <FileText className="h-12 w-12 text-gray-400 mx-auto mb-3" />
//           <h3 className="text-lg font-medium text-gray-900 mb-1">No invoices found</h3>
//           <p className="text-gray-500">
//             {searchTerm || filterStatus !== 'all' 
//               ? 'Try adjusting your search or filter criteria'
//               : 'Your invoice history will appear here'}
//           </p>
//         </motion.div>
//       ) : (
//         <div className="space-y-3">
//           {filteredInvoices.map((invoice, index) => (
//             <motion.div
//               key={invoice._id}
//               initial={{ opacity: 0, x: -20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ delay: index * 0.05 }}
//               className="flex flex-col sm:flex-row sm:items-center justify-between p-4 bg-white dark:bg-dark-900 rounded-xl border border-gray-200 dark:border-dark-800 hover:shadow-md transition-all"
//             >
//               <div className="flex items-start gap-4">
//                 <div className="w-10 h-10 bg-primary-100 dark:bg-primary-900/20 rounded-lg flex items-center justify-center">
//                   <FileText className="h-5 w-5 text-primary-600" />
//                 </div>
//                 <div>
//                   <div className="flex items-center gap-2 flex-wrap">
//                     <p className="font-medium text-gray-900">
//                       {invoice.plan} Plan - {invoice.billingCycle || 'Monthly'}
//                     </p>
//                     <span className={`px-2 py-0.5 text-xs rounded-full ${
//                       invoice.status === 'paid' 
//                         ? 'bg-green-100 text-green-700'
//                         : invoice.status === 'pending'
//                         ? 'bg-yellow-100 text-yellow-700'
//                         : 'bg-red-100 text-red-700'
//                     }`}>
//                       {invoice.status || 'Paid'}
//                     </span>
//                   </div>
//                   <div className="flex items-center gap-4 mt-1 text-sm text-gray-500">
//                     <span className="flex items-center gap-1">
//                       <Calendar className="h-3 w-3" />
//                       {formatDate(invoice.createdAt)}
//                     </span>
//                     <span className="flex items-center gap-1">
//                       <DollarSign className="h-3 w-3" />
//                       {formatCurrency(invoice.amount || invoice.price?.amount, invoice.currency)}
//                     </span>
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     Invoice #{invoice._id.slice(-8).toUpperCase()}
//                   </p>
//                 </div>
//               </div>
//               <div className="flex items-center gap-2 mt-3 sm:mt-0">
//                 <button
//                   onClick={() => handleSendInvoice(invoice._id)}
//                   className="px-3 py-1.5 text-sm text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
//                 >
//                   Email
//                 </button>
//                 <button
//                   onClick={() => handleDownloadInvoice(invoice._id)}
//                   disabled={downloadingId === invoice._id}
//                   className="btn-secondary flex items-center gap-1"
//                 >
//                   {downloadingId === invoice._id ? (
//                     <Loader2 className="h-4 w-4 animate-spin" />
//                   ) : (
//                     <Download className="h-4 w-4" />
//                   )}
//                   PDF
//                 </button>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default InvoicesPage;















// // client/src/pages/user/InvoicesPage.jsx - FIXED PDF download
// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import { 
//   FileText, Download, Loader2, Calendar, 
//   DollarSign, CheckCircle, Search, Filter, Eye
// } from 'lucide-react';
// import toast from 'react-hot-toast';
// import subscriptionAPI from '../../api/subscriptionAPI';

// const InvoicesPage = () => {
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [downloadingId, setDownloadingId] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');

//   useEffect(() => {
//     fetchInvoices();
//   }, []);

//   const fetchInvoices = async () => {
//     setLoading(true);
//     try {
//       const response = await subscriptionAPI.getBillingHistory();
//       // Handle different response formats
//       let invoicesData = response?.data || response || [];
//       if (invoicesData.data) invoicesData = invoicesData.data;
//       if (!Array.isArray(invoicesData)) invoicesData = [];
//       setInvoices(invoicesData);
//     } catch (error) {
//       console.error('Error fetching invoices:', error);
//       toast.error('Failed to load invoices');
//       setInvoices([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (date) => {
//     if (!date) return 'N/A';
//     return new Date(date).toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const formatCurrency = (amount, currency = 'INR') => {
//     if (!amount && amount !== 0) return '₹0';
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: currency,
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const handleDownloadInvoice = async (invoiceId) => {
//     setDownloadingId(invoiceId);
//     try {
//       const blob = await subscriptionAPI.downloadInvoice(invoiceId);
      
//       // Check if blob is valid
//       if (!blob || blob.size === 0) {
//         throw new Error('Empty file received');
//       }
      
//       // Create download link
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `invoice_${invoiceId}.html`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//       toast.success('Invoice downloaded successfully');
//     } catch (error) {
//       console.error('Error downloading invoice:', error);
//       toast.error(error.response?.data?.message || 'Failed to download invoice');
//     } finally {
//       setDownloadingId(null);
//     }
//   };

//   const handleViewInvoice = async (invoiceId) => {
//     setDownloadingId(invoiceId);
//     try {
//       const blob = await subscriptionAPI.downloadInvoice(invoiceId);
      
//       if (!blob || blob.size === 0) {
//         throw new Error('Empty file received');
//       }
      
//       const url = window.URL.createObjectURL(blob);
//       window.open(url, '_blank');
//       window.URL.revokeObjectURL(url);
      
//     } catch (error) {
//       console.error('Error viewing invoice:', error);
//       toast.error('Failed to view invoice');
//     } finally {
//       setDownloadingId(null);
//     }
//   };

//   const handleSendInvoice = async (invoiceId) => {
//     try {
//       await subscriptionAPI.sendInvoiceEmail(invoiceId);
//       toast.success('Invoice sent to your email');
//     } catch (error) {
//       console.error('Error sending invoice:', error);
//       toast.error(error.response?.data?.message || 'Failed to send invoice');
//     }
//   };

//   // Filter invoices
//   const filteredInvoices = invoices.filter(invoice => {
//     const planName = (invoice.plan || '').toLowerCase();
//     const invoiceId = (invoice._id || '').toLowerCase();
//     const matchesSearch = planName.includes(searchTerm.toLowerCase()) ||
//                           invoiceId.includes(searchTerm.toLowerCase());
//     const matchesStatus = filterStatus === 'all' || invoice.status === filterStatus;
//     return matchesSearch && matchesStatus;
//   });

//   const stats = {
//     total: invoices.length,
//     paid: invoices.filter(i => i.status === 'active' || i.status === 'paid' || i.status === 'Paid').length,
//     totalSpent: invoices.reduce((sum, i) => sum + (i.price?.amount || i.amount || 0), 0)
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-[60vh]">
//         <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-6">
//       {/* Header */}
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//       >
//         <h1 className="text-2xl font-bold text-gray-900 mb-2">Invoices</h1>
//         <p className="text-gray-500">View and download all your payment receipts</p>
//       </motion.div>

//       {/* Stats Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.1 }}
//           className="card p-4"
//         >
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Total Invoices</p>
//               <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
//             </div>
//             <FileText className="h-8 w-8 text-primary-600" />
//           </div>
//         </motion.div>

//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.15 }}
//           className="card p-4"
//         >
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Paid Invoices</p>
//               <p className="text-2xl font-bold text-green-600">{stats.paid}</p>
//             </div>
//             <CheckCircle className="h-8 w-8 text-green-600" />
//           </div>
//         </motion.div>

//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.2 }}
//           className="card p-4"
//         >
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-sm text-gray-500">Total Spent</p>
//               <p className="text-2xl font-bold text-gray-900">{formatCurrency(stats.totalSpent)}</p>
//             </div>
//             <DollarSign className="h-8 w-8 text-yellow-600" />
//           </div>
//         </motion.div>
//       </div>

//       {/* Search and Filter */}
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.25 }}
//         className="flex flex-col sm:flex-row gap-4"
//       >
//         <div className="flex-1 relative">
//           <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
//           <input
//             type="text"
//             placeholder="Search invoices..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="input-field pl-10"
//           />
//         </div>
//         <select
//           value={filterStatus}
//           onChange={(e) => setFilterStatus(e.target.value)}
//           className="input-field w-full sm:w-40"
//         >
//           <option value="all">All Status</option>
//           <option value="paid">Paid</option>
//           <option value="pending">Pending</option>
//           <option value="failed">Failed</option>
//         </select>
//       </motion.div>

//       {/* Invoices List */}
//       {filteredInvoices.length === 0 ? (
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           className="card p-12 text-center"
//         >
//           <FileText className="h-12 w-12 text-gray-400 mx-auto mb-3" />
//           <h3 className="text-lg font-medium text-gray-900 mb-1">No invoices found</h3>
//           <p className="text-gray-500">
//             {searchTerm || filterStatus !== 'all' 
//               ? 'Try adjusting your search or filter criteria'
//               : 'Your invoice history will appear here'}
//           </p>
//         </motion.div>
//       ) : (
//         <div className="space-y-3">
//           {filteredInvoices.map((invoice, index) => (
//             <motion.div
//               key={invoice._id}
//               initial={{ opacity: 0, x: -20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ delay: index * 0.05 }}
//               className="flex flex-col sm:flex-row sm:items-center justify-between p-4 bg-white dark:bg-dark-900 rounded-xl border border-gray-200 dark:border-dark-800 hover:shadow-md transition-all"
//             >
//               <div className="flex items-start gap-4">
//                 <div className="w-10 h-10 bg-primary-100 dark:bg-primary-900/20 rounded-lg flex items-center justify-center">
//                   <FileText className="h-5 w-5 text-primary-600" />
//                 </div>
//                 <div>
//                   <div className="flex items-center gap-2 flex-wrap">
//                     <p className="font-medium text-gray-900 capitalize">
//                       {invoice.plan || 'Unknown'} Plan - {invoice.billingCycle || 'Monthly'}
//                     </p>
//                     <span className={`px-2 py-0.5 text-xs rounded-full ${
//                       invoice.status === 'active' || invoice.status === 'paid' || invoice.status === 'Paid'
//                         ? 'bg-green-100 text-green-700'
//                         : invoice.status === 'pending'
//                         ? 'bg-yellow-100 text-yellow-700'
//                         : 'bg-red-100 text-red-700'
//                     }`}>
//                       {invoice.status === 'active' ? 'Paid' : invoice.status || 'Paid'}
//                     </span>
//                   </div>
//                   <div className="flex items-center gap-4 mt-1 text-sm text-gray-500">
//                     <span className="flex items-center gap-1">
//                       <Calendar className="h-3 w-3" />
//                       {formatDate(invoice.createdAt)}
//                     </span>
//                     <span className="flex items-center gap-1">
//                       <DollarSign className="h-3 w-3" />
//                       {formatCurrency(invoice.price?.amount || invoice.amount, invoice.price?.currency || 'INR')}
//                     </span>
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     Invoice #{invoice._id?.slice(-8).toUpperCase() || 'N/A'}
//                   </p>
//                 </div>
//               </div>
//               <div className="flex items-center gap-2 mt-3 sm:mt-0">
//                 <button
//                   onClick={() => handleSendInvoice(invoice._id)}
//                   className="px-3 py-1.5 text-sm text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
//                 >
//                   Email
//                 </button>
//                 <button
//                   onClick={() => handleViewInvoice(invoice._id)}
//                   className="px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-100 rounded-lg transition-colors inline-flex items-center gap-1"
//                 >
//                   <Eye className="h-3 w-3" />
//                   View
//                 </button>
//                 <button
//                   onClick={() => handleDownloadInvoice(invoice._id)}
//                   disabled={downloadingId === invoice._id}
//                   className="btn-secondary flex items-center gap-1 disabled:opacity-50"
//                 >
//                   {downloadingId === invoice._id ? (
//                     <Loader2 className="h-4 w-4 animate-spin" />
//                   ) : (
//                     <Download className="h-4 w-4" />
//                   )}
//                   PDF
//                 </button>
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default InvoicesPage;




















// client/src/pages/user/InvoicesPage.jsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { 
  FileText, Download, Loader2, Calendar, 
  DollarSign, CheckCircle, Search, Filter, Eye
} from 'lucide-react';
import toast from 'react-hot-toast';
import subscriptionAPI from '../../api/subscriptionAPI';

const InvoicesPage = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingId, setDownloadingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const response = await subscriptionAPI.getBillingHistory();
      // Handle different response formats
      let invoicesData = response?.data || response || [];
      if (invoicesData.data) invoicesData = invoicesData.data;
      if (!Array.isArray(invoicesData)) invoicesData = [];
      setInvoices(invoicesData);
    } catch (error) {
      console.error('Error fetching invoices:', error);
      toast.error('Failed to load invoices');
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatCurrency = (amount, currency = 'INR') => {
    if (!amount && amount !== 0) return '₹0';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // FIXED: Use subscriptionAPI.downloadInvoice which handles the blob properly
  const handleDownloadInvoice = async (invoiceId) => {
    setDownloadingId(invoiceId);
    try {
      await subscriptionAPI.downloadInvoice(invoiceId);
      toast.success('Invoice downloaded successfully');
    } catch (error) {
      console.error('Error downloading invoice:', error);
      toast.error(error.response?.data?.message || 'Failed to download invoice');
    } finally {
      setDownloadingId(null);
    }
  };

  // FIXED: View invoice in new tab
  const handleViewInvoice = async (invoiceId) => {
    setDownloadingId(invoiceId);
    try {
      await subscriptionAPI.viewInvoice(invoiceId);
    } catch (error) {
      console.error('Error viewing invoice:', error);
      toast.error('Failed to view invoice');
    } finally {
      setDownloadingId(null);
    }
  };

  const handleSendInvoice = async (invoiceId) => {
    try {
      await subscriptionAPI.sendInvoiceEmail(invoiceId);
      toast.success('Invoice sent to your email');
    } catch (error) {
      console.error('Error sending invoice:', error);
      toast.error(error.response?.data?.message || 'Failed to send invoice');
    }
  };

  // Filter invoices
  const filteredInvoices = invoices.filter(invoice => {
    const planName = (invoice.plan || '').toLowerCase();
    const invoiceId = (invoice._id || '').toLowerCase();
    const matchesSearch = planName.includes(searchTerm.toLowerCase()) ||
                          invoiceId.includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || 
                          (filterStatus === 'paid' && (invoice.status === 'active' || invoice.status === 'paid')) ||
                          (filterStatus === invoice.status);
    return matchesSearch && matchesStatus;
  });

  const stats = {
    total: invoices.length,
    paid: invoices.filter(i => i.status === 'active' || i.status === 'paid' || i.status === 'Paid').length,
    totalSpent: invoices.reduce((sum, i) => sum + (i.price?.amount || i.amount || 0), 0)
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Invoices</h1>
        <p className="text-gray-500 dark:text-gray-400">View and download all your payment receipts</p>
      </motion.div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="bg-white dark:bg-gray-900 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-800"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Total Invoices</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{stats.total}</p>
            </div>
            <FileText className="h-8 w-8 text-primary-600" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 }}
          className="bg-white dark:bg-gray-900 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-800"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Paid Invoices</p>
              <p className="text-2xl font-bold text-green-600">{stats.paid}</p>
            </div>
            <CheckCircle className="h-8 w-8 text-green-600" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-white dark:bg-gray-900 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-800"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">Total Spent</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{formatCurrency(stats.totalSpent)}</p>
            </div>
            <DollarSign className="h-8 w-8 text-yellow-600" />
          </div>
        </motion.div>
      </div>

      {/* Search and Filter */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.25 }}
        className="flex flex-col sm:flex-row gap-4"
      >
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search invoices..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 pl-10 border border-gray-300 dark:border-gray-700 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          />
        </div>
        <select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
          className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-white w-full sm:w-40"
        >
          <option value="all">All Status</option>
          <option value="paid">Paid</option>
          <option value="pending">Pending</option>
          <option value="failed">Failed</option>
        </select>
      </motion.div>

      {/* Invoices List */}
      {filteredInvoices.length === 0 ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="bg-white dark:bg-gray-900 rounded-xl p-12 text-center border border-gray-200 dark:border-gray-800"
        >
          <FileText className="h-12 w-12 text-gray-400 mx-auto mb-3" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-1">No invoices found</h3>
          <p className="text-gray-500 dark:text-gray-400">
            {searchTerm || filterStatus !== 'all' 
              ? 'Try adjusting your search or filter criteria'
              : 'Your invoice history will appear here'}
          </p>
        </motion.div>
      ) : (
        <div className="space-y-3">
          {filteredInvoices.map((invoice, index) => (
            <motion.div
              key={invoice._id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.05 }}
              className="flex flex-col sm:flex-row sm:items-center justify-between p-4 bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 hover:shadow-md transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-primary-100 dark:bg-primary-900/20 rounded-lg flex items-center justify-center">
                  <FileText className="h-5 w-5 text-primary-600" />
                </div>
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <p className="font-medium text-gray-900 dark:text-white capitalize">
                      {invoice.plan || 'Unknown'} Plan - {invoice.billingCycle || 'Monthly'}
                    </p>
                    <span className={`px-2 py-0.5 text-xs rounded-full ${
                      invoice.status === 'active' || invoice.status === 'paid' || invoice.status === 'Paid'
                        ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                        : invoice.status === 'pending'
                        ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400'
                        : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
                    }`}>
                      {invoice.status === 'active' ? 'Paid' : invoice.status || 'Paid'}
                    </span>
                  </div>
                  <div className="flex items-center gap-4 mt-1 text-sm text-gray-500 dark:text-gray-400">
                    <span className="flex items-center gap-1">
                      <Calendar className="h-3 w-3" />
                      {formatDate(invoice.createdAt)}
                    </span>
                    <span className="flex items-center gap-1">
                      <DollarSign className="h-3 w-3" />
                      {formatCurrency(invoice.price?.amount || invoice.amount, invoice.price?.currency || 'INR')}
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                    Invoice #{invoice._id?.slice(-8).toUpperCase() || 'N/A'}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-3 sm:mt-0">
                <button
                  onClick={() => handleSendInvoice(invoice._id)}
                  className="px-3 py-1.5 text-sm text-primary-600 hover:bg-primary-50 dark:hover:bg-primary-900/30 rounded-lg transition-colors"
                >
                  Email
                </button>
                <button
                  onClick={() => handleViewInvoice(invoice._id)}
                  className="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors inline-flex items-center gap-1"
                >
                  <Eye className="h-3 w-3" />
                  View
                </button>
                <button
                  onClick={() => handleDownloadInvoice(invoice._id)}
                  disabled={downloadingId === invoice._id}
                  className="px-4 py-1.5 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center gap-1"
                >
                  {downloadingId === invoice._id ? (
                    <Loader2 className="h-4 w-4 animate-spin" />
                  ) : (
                    <Download className="h-4 w-4" />
                  )}
                  PDF
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InvoicesPage;